(function ($) {
  jQuery(document).ready(function () {  
    // Header menu dropdown hover
    $( "nav.header__inline-menu .header__menu-item" ).hover(
      function() {
        $( this ).attr('aria-expanded', true);
        $( this ).closest('details').attr('open', 'true');
      }, function() {
        $( this ).attr('aria-expanded', false);
        $( this ).closest('details').removeAttr('open');
      }
    );
    // Keep 'open' attribute when hovering over the submenu
    $( "nav.header__inline-menu .header__submenu" ).hover(
      function() {
        // Keep the submenu open when hovering over it
        $( this ).closest('details').attr('open', 'open');
      }, function() {
        // Do nothing when hovering out of the submenu to avoid closing it
      }
    );
    
    // Homepage Popular Services Slider
    if($('.popular-services-slider').length > 0) {
      var swiper = new Swiper(".popular-services-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".popular-services-button-next",
          prevEl: ".popular-services-button-prev",
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 13,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 13,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1023: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1199: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 13,
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 13,
          },
          1601: {
            slidesPerView: 3,
            spaceBetween: 23,
          },
        },
      });
    }
    // Homepage Featured Repairers
    if($('.featured-repairers-slider').length > 0) {
      var swiper = new Swiper(".featured-repairers-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".featured-repairers-button-next",
          prevEl: ".featured-repairers-button-prev",
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 11,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 11,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1440: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1441: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
        },
      });
    }
    // Homepage Our Customer
    if($('.our-customers-slider').length > 0) {
      var swiper = new Swiper(".our-customers-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".our-customers-button-next",
          prevEl: ".our-customers-button-prev",
        },
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 17,
          },
          1440: {
            slidesPerView: 3,
            spaceBetween: 17,
          },
          1441: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
        },
        pagination: {
          el: ".our-customers-pagination",
          clickable: true 
        },
      });
    }
    // Homepage Blog Posts
    if($('.blog-posts-slider').length > 0) {
      var swiper = new Swiper(".blog-posts-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".blog-posts-button-next",
          prevEl: ".blog-posts-button-prev",
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 9,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 9,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1440: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1441: {
            slidesPerView: 2,
            spaceBetween: 19.5,
          },
        },
      });
    }

    // Appliance Repairs Services
    if($('.appliance-repairs-services').length > 0) {
      var myswiper = new Swiper(".appliance-repairs-services", {
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".appliance-repairs-button-next",
          prevEl: ".appliance-repairs-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 11,
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 11,
          },
          991: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1199: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 17,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 17,
          },
          1441: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        },
      });
    }
    
    //  Header Height
    function tooeziHeight() {          
      var header_height = $(".shopify-section.section-header").outerHeight();
      var footer_height = $(".shopify-section-group-footer-group").outerHeight();
      $("html").css("--heightFooter", footer_height + "px");
      $("html").css("--heightHeader", header_height + "px");
      $("html").css('--heightScreen', `${window.innerHeight}px`)
      
      if($('.section-image-banner').length > 0) {
        $(".shopify-section.section-header").addClass('section-has-banner');
      } else {
        $(".shopify-section.section-header").removeClass('section-has-banner');
      }
    }
    function headerFixed() {    
      var header = $('.shopify-section.section-header'),
          scroll = $(window).scrollTop();
      if (scroll > 0) { 
          header.addClass('has-sticky'); 
      } else { 
          header.removeClass('has-sticky');
      }
    }
    tooeziHeight();
    headerFixed()
    $(window).on('resize load', function(){
      tooeziHeight();
      blogContent();
    });  
    
    // Homepage Our job stats
    if($('.count.percent').length > 0) {
      $('.count.percent').countUp({
        delay: 10,
        time: 1000,
        scrollSpyOnce: false
      });
    }
    
    $(window).scroll(function() {
      // Header Fixed
      headerFixed();
    });

	// Change page title for cms page
	$('.cms-page .page-title').html(function() {
        var text = $(this).text().split(' ');
        var last = text.pop();
        return text.join(" ") + (text.length > 0 ? ' <span class="last">' + last + '</span>' : last);
    });

    $('#subject').change(function() {
      $('option:selected', this).addClass('active').siblings().removeClass('active');
      $(this).parent().addClass('active');
    });   

    // Blog Post hover
    blogContent();
    function blogContent() {
      if($('.article-card .card__information-content').length > 0) {
        $( ".article-card" ).hover(
          function() {
            if($( this ).find('.card__information-content').is(":hidden")) {
              $( this ).find('.card__information-content').slideDown('350');
            }
          }, function() {
            if($( this ).find('.card__information-content').is(":visible")) {
              $( this ).find('.card__information-content').slideUp('350');
            }
          }
        );
        var heightsBlogContent = $(".article-card .card__information-content-hidden").map(function ()
        {
            return $(this).height();
        }).get();
        maxHeightContent = Math.max.apply(null, heightsBlogContent);
        var heightsBlogItem = $(".article-card").map(function ()
        {
            return $(this).height();
        }).get();
        maxHeightItem = Math.max.apply(null, heightsBlogItem);
        $('.blog-posts-items').css('--height-content', maxHeightContent + 'px')
        $('.blog-posts-items').css('--height-item', maxHeightItem + 'px')        
      }
    }

    // Pages: Appliance Supply & Install
    if($('.collection-list-slider').length > 0) {
      new Swiper(".collection-list-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: ".collection-list-button-next",
          prevEl: ".collection-list-button-prev",
        },
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 13,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 13,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1023: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1199: {
            slidesPerView: 2,
            spaceBetween: 13,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 13,
          },
          1600: {
            slidesPerView: 4,
            spaceBetween: 13,
          },
          1601: {
            slidesPerView: 5,
            spaceBetween: 13,
          },
        },
        pagination: {
          el: ".collection-list-pagination",
          clickable: true 
        },
      });
    }
    if($('.collection-list-toolbar').length > 0) {
      var countProducts = $('.collection-list-toolbar').attr('data-count');
      $('.collection-list-toolbar .collection-list_sort-by .sort-by label').click(function(){
        $(this).toggleClass('active').next('ul').slideToggle();
      });
      $('.collection-list-toolbar .collection-list_sort-by .sort-by li').click(function(){
        $(this).addClass('active').parent('ul').slideToggle();
        $('.sort-by label').removeClass('active');
        $(this).siblings('li').removeClass('active');
        $(this).parents('.sort-by').find('label').text($(this).text());
        var dataSort = $(this).attr('data-sort');
        if(dataSort == 'sort-popular') {
          var countPopular = 0;
          $('.product-grid .grid__item').removeClass('visible-hidden');  
          $('.product-grid .grid__item').each(function() {
            if($(this).attr('data-popular') != dataSort) {
              $(this).addClass('hidden');
            } else {
              $(this).removeClass('hidden');
              countPopular = countPopular + 1;
            }
          });
          $('.collection-list_result .result-count').text(countPopular);
        }
        if(dataSort == 'sort-alphabet') {
          $('.collection-list_result .result-count').text(countProducts);
          $('.product-grid .grid__item').removeClass('hidden');  
          $('.product-grid .grid__item').removeClass('visible-hidden');  
         $('select#SortBy').val('title-ascending').change()
        }
        if(dataSort == 'most-recent') {
          loadRecentLinks();
        }
      });
      $(document).click(function (e) {
          var $target = $(e.target);
          if (!$target.closest('.sort-by').length && $('.sort-by').is(':visible')) {
              $('.sort-by label').removeClass('active');
            $('.collection-list-toolbar .collection-list_sort-by .sort-by ul').slideUp();
          }
      });
      function storeLink(link) {
        var recentLinks = JSON.parse(localStorage.getItem('recentLinks')) || [];
      
        // If the link is already in the list, remove it (to move it to the top)
        recentLinks = recentLinks.filter(function (item) {
            return item !== link;
        });
      
        // Add the link to the top of the list
        recentLinks.unshift(link);
      
        // Store the updated list back in localStorage
        localStorage.setItem('recentLinks', JSON.stringify(recentLinks));
      }
      
      // Function to load and display recent links
      function loadRecentLinks() {
        var recentLinks = JSON.parse(localStorage.getItem('recentLinks')) || [];
        var countLinks = recentLinks.length;
        $('.collection-list_result .result-count').text(countLinks);
      
        // // Loop through the links and append them to the list
        recentLinks.forEach(function (link) {
          $('.product-grid .grid__item').each(function() {
            $('.product-grid .grid__item').addClass('hidden');
            // setTimeout(function() { 
              if($(this).attr('data-handle') == link) {
                $(this).removeClass('hidden');
                $(this).addClass('visible-hidden');
              }
            // }, 1000);
          })
        });
      }
      
      // Track clicks on the links
      $('.product-grid .grid__item').click(function (e) {
        var link = $(this).attr('data-handle');
        storeLink(link);
      });
      
    }

    // Pages: IKEA Kitchen Installation
    // Kitchen pricing costs
    if($('.kitchen-pricing-costs-slider').length > 0) {
      new Swiper(".kitchen-pricing-costs-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".kitchen-pricing-costs-pagination",
          clickable: true 
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }
    
    // Kitchen factors
    if($('.kitchen-installation-factors-slider').length > 0) {
      new Swiper(".kitchen-installation-factors-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".kitchen-installation-factors-pagination",
          clickable: true 
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    }
    if($('#datepicker').length > 0) {
      $('#datepicker').datetimepicker();
    }
    if($('.kitchen-pricing-costs').length > 0) {
      $('.kitchen-pricing-costs .read-more').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $('.kitchen-pricing-costs .less-more').show();
        $('.section-header__content_more').slideDown();
      });
      $('.kitchen-pricing-costs .less-more').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $('.kitchen-pricing-costs .read-more').show();
        $('.section-header__content_more').slideUp();
      });
    }
    
    // if($('#ContactForm-upload_kitchen').length > 0) {
    //   $('#ContactForm-upload_kitchen').customFileInput({
    //       inputText: 'My Kitchen.pdf'
    //   });
    // }
    if($('#ContactForm').length > 0) {
      $("#ContactForm").validate();
    }
    // if($('#ContactForm-additional').length > 0) {
    //   var additionalPlaceholder = $('#ContactForm-additional').attr('placeholder');
    //   $('#ContactForm-additional').customFileInput({
    //       inputText: additionalPlaceholder
    //   });
    //   // jQuery to add class on file select
    //   $('#ContactForm-additional').on('change', function() {
    //     if (this.files && this.files.length > 0) {
    //       $(this).parents('.field-additional').addClass('file-selected');
    //     } else {
    //       $(this).parents('.field-additional').removeClass('file-selected');
    //     }
    //   });
    // }
    
    // List of service categories
    if($('.service-type-slider').length > 0) {
      var swiper = new Swiper(".service-type-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".service-type-pagination",
          clickable: true 
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 13,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 17,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 17,
          }
        },
      });
    }
    
    if($('.service-popular-projects .popular-projects-tab').length > 0) {
      if($('.service-topics-image-slider').length > 0) {
        var topicswiper = new Swiper(".service-topics-image-slider", {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: ".service-topics-button-next",
            prevEl: ".service-topics-button-prev",
          },
          on: {
            slideChange: function() {
              var activeSlide = this.slides[this.activeIndex];
              var dataId = $(activeSlide).data('id');
      
              // Add 'active' class to corresponding subtopic-item and item
              $('.popular-projects-tab .item').removeClass('active');
              $('.popular-projects-tab .subtopic-item').removeClass('active');
              var activeSubtopic = $('.subtopic-item[data-id="'+dataId+'"]');
              activeSubtopic.addClass('active');
      
              var parentItem = activeSubtopic.parents('.item');
              parentItem.addClass('active');
      
              // Ensure the content is shown and hide siblings' content
              parentItem.find('.content').slideDown();
              parentItem.siblings('.item').find('.content').slideUp();
            }
          }
        });
      }
      $('.popular-projects-tab .title').click(function() {
        var $item = $(this).parents('.item');
        var dataId = $item.find('.subtopic-item').first().data('id');
    
        // Toggle visibility of content
        $(this).next('.content').slideToggle();
        $item.toggleClass('active');
        
        // Slide up other items and deactivate their associated subtopics
        $item.siblings('.item').removeClass('active').find('.content').slideUp();
        $('.subtopic-item').removeClass('active');
    
        $item.find('.subtopic-item').first().addClass('active');
    
        // Activate the corresponding slide in Swiper for the first subtopic-item
        var slideIndex = $('.topic-image[data-id="'+dataId+'"]').index();
        topicswiper.slideTo(slideIndex);
      });
    
      if($('.subtopic-item').length > 0) {
        $('.subtopic-item').click(function() {
          var dataId = $(this).data('id');
      
          // Activate the corresponding item and topic-image
          $('.item[data-id="'+dataId+'"]').addClass('active');
          $('.topic-image[data-id="'+dataId+'"]').addClass('active');
      
          // Slide to the corresponding Swiper slide
          var slideIndex = $('.topic-image[data-id="'+dataId+'"]').index();
          topicswiper.slideTo(slideIndex);
          
          // Toggle the content visibility for the clicked subtopic
          $(this).siblings('.content').slideToggle();
        });
      }
    }

    if($('.button-quote-request-form').length > 0) {
      // When the button is clicked
      $('.button-quote-request-form').on('click', function() {
        // Scroll to the div with the class 'service-quote-request-form'
        $('html, body').animate({
          scrollTop: $('.service-quote-request-form').offset().top
        }, 1000); // 1000 is the duration of the scroll in milliseconds (1 second)
      });
    }
    if ($('.select-categories').length > 0 && $('#ContactForm-category').length > 0) {
      // Move forms to target containers after a delay
      setTimeout(function () {
        $('.service-categories-select-form').appendTo('#field-service-categories').show();
        $('.service-types-select-form').appendTo('#field-service-types').show();
      }, 100);
  
      // Define updateActiveClass function using jQuery
      function updateActiveClass(dataId) {
        $('#service-select-types li').removeClass('active');
        const $matchingTypes = $('#service-select-types li[data-id="' + dataId + '"]');
        if ($matchingTypes.length > 0) {
          $matchingTypes.addClass('active');
        } else {
          console.warn('No matching li for data-id:', dataId);
        }
      }
  
      // Expose updateActiveClass globally
      window.updateActiveClass = updateActiveClass;
  
      // Initial: Add 'active' class based on the selected category
      const $selectedCategory = $('#service-select-categories .selected');
      if ($selectedCategory.length) {
        updateActiveClass($selectedCategory.attr('data-id'));
      } else {
        console.warn('No selected <li> found in #service-select-categories');
      }
  
      // Click event for #service-select-categories li
      $('#service-select-categories li').on('click', function () {
        const dataId = $(this).attr('data-id');
        updateActiveClass(dataId);
      });
  
      // Toggle dropdown visibility on label click
      $('.service-categories-select .label-categories').on('click', function (event) {
        event.stopPropagation();
        const $parent = $(this).parent('.service-categories-select');
        const $list = $parent.find('.select-categories');
        const isVisible = $list.is(':visible');
        $('.select-categories').slideUp('fast');
        $('.service-categories-select').removeClass('active');
        if (!isVisible) {
          $list.slideDown('fast');
          $parent.addClass('active');
        }
      });
  
      // Handle selection in .service-categories-select (non-form)
      $('.service-categories-select:not(.service-categories-select-form) .select-categories-category li').on('click', function () {
        const $this = $(this);
        const $parent = $this.parents('.service-categories-select');
        const selectedCategory = $this.text();
        const dataId = $this.attr('data-id');
        const value = $this.attr('value');
  
        $parent.find('.select-categories li').removeClass('selected');
        $this.addClass('selected');
        $parent.find('.label-categories').text(selectedCategory);
  
        $('#service-select-categories li').removeClass('selected');
        const $matchingCategory = $('#service-select-categories li[data-id="' + dataId + '"]');
        if ($matchingCategory.length) $matchingCategory.addClass('selected');
  
        if ($('#ContactForm-category option[value="' + value + '"]').length) {
          $('#ContactForm-category').val(value).trigger('change');
        }
  
        if (window.allItems && Array.isArray(window.allItems)) {
          const matchingItem = window.allItems.find(item => item.dataId === dataId);
          if (matchingItem && $('#ContactForm-type option[value="' + matchingItem.handle + '"]').length) {
            $('#ContactForm-type').val(matchingItem.handle).trigger('change');
          }
        }
  
        if (typeof window.updateActiveClass === 'function') {
          window.updateActiveClass(dataId);
        }
  
        $parent.find('.select-categories').slideUp('fast');
        $parent.removeClass('active');

        $('.categories-tabs .category-tab').removeClass('active');
        $('.categories-tabs .category-tab[id="'+ dataId +'"]').addClass('active')
      });
  
      // Close dropdown on outside click
      $(document).on('click', function (event) {
        if (!$(event.target).closest('.service-categories-select').length) {
          $('.select-categories').slideUp('fast');
          $('.service-categories-select').removeClass('active');
        }
      });
    }
    $('.select-categories-category li').on('click', function () {
      const $this = $(this);
      const $parent = $this.parents('.service-categories-select');
      const selectedCategory = $this.text();
      const dataId = $this.attr('data-id');
      const value = $this.attr('value');

      // Reset selected class in Service Types
      $('#service-select-types li').removeClass('selected');
      $('.service-types-select-form .label-categories').text('Select a Service Type');
      
      $parent.find('.select-categories li').removeClass('selected');
      $this.addClass('selected');
      $parent.find('.label-categories').text(selectedCategory);
    
      $('#service-select-categories li').removeClass('selected');
      const $matchingCategory = $('#service-select-categories li[data-id="' + dataId + '"]');
      if ($matchingCategory.length) {
        $matchingCategory.addClass('selected');
        var $matchingCategoryLabel = $matchingCategory.text();
        $matchingCategory.parents('.service-categories-select-form').find('.label-categories').text($matchingCategoryLabel);
      }
    
      if ($('#ContactForm-category option[value="' + value + '"]').length) {
        $('#ContactForm-category').val(value).trigger('change');
      }
    
      if (window.allItems && Array.isArray(window.allItems)) {
        const matchingItem = window.allItems.find(item => item.dataId === dataId);
        if (matchingItem && $('#ContactForm-type option[value="' + matchingItem.handle + '"]').length) {
          $('#ContactForm-type').val(matchingItem.handle).trigger('change');
        }
      }
    
      if (typeof window.updateActiveClass === 'function') {
        window.updateActiveClass(dataId);
      }
    
      $parent.find('.select-categories').slideUp('fast');
      $parent.removeClass('active');
    });
    $('.select-categories-type li').click(function() {
      var selectedText = $(this).text();              // Get the text of clicked li
      var selectedValue = $(this).attr('value');      // Get the value attribute
  
      // Add class to clicked li, remove from siblings
      $(this).addClass('selected').siblings().removeClass('selected');
  
      // Update label text
      $(this).parents('.service-types-select-form').removeClass('active').find('.label-categories').text(selectedText);
  
      // Slide up the list
      $(this).parent('.select-categories-type').slideUp('fast');
  
      // Set value in select box
      $('#ContactForm-type').val(selectedValue).change(); // .change() triggers any change listeners
    });
    if ($('.category-item .card').length > 0 && $('#ContactForm-type').length > 0) {
      // When a card inside .category-item is clicked
      $('.category-item .card a').on('click', function(e) {
        e.preventDefault();
      });
      $('.category-item .card').on('click', function() {
        // Get the value of the data-id attribute from the clicked card
        var selectedValue = $(this).data('id');
        
        // Check if the selected value exists as an option in the #ContactForm-type select dropdown
        if ($('#ContactForm-type option[value="' + selectedValue + '"]').length > 0) {
          // Set the value of the #ContactForm-type select element to the value from data-id
          $('#ContactForm-type').val(selectedValue);
    
          // Trigger the change event for the select element to execute any associated logic
          $('#ContactForm-type').trigger('change');
        }
      });
    }


  });
})(jQuery);
